import { createDomain } from 'effector';
import $$api from 'models/api';

import { type Answers } from 'types/zod/answers';
import { type Question } from 'types/zod/question';
import { type QuestionnaireInstance } from 'types/zod/questionnaire-instance';
import { type TrustFundingAsset } from 'types/zod/trust-funding-asset';

const domain = createDomain('pages/trust-funding');

// TODO: Need to move all TF-related samples to models/trust-funding ($$tf), and leave only page-related samples here ($$trustFunding)

const $$trustFunding = {
    $pageIsAvailable: domain.store<boolean>(false),
    $categories: domain.store<string[]>([]),
    $isAlreadyCreated: domain.store<boolean>(false),
    $questionnaire: domain.store<Question | null>(null),
    $qInstance: domain.store<QuestionnaireInstance | null>(null),
    $answers: domain.store<Answers | null>(null),
    $assets: domain.store<TrustFundingAsset[]>([]),

    createQInstanceButtonClicked: domain.event<void>(),
    deleteAssetClicked: domain.event<TrustFundingAsset['id']>(),
    addAssetClicked: domain.event<void>(),
    doneAssetClicked: domain.event<TrustFundingAsset['id']>(),
    printInstructionsButtonClicked: domain.event<void>(),
    assetClicked: domain.event<TrustFundingAsset['id']>(),

    createTrustFundingFx: domain.effect($$api.qInstances.createIncludedInstanceFx),
};

export default $$trustFunding;
